exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".monaco-live-analysis-override{margin-left:5px;font-size:.7rem;transition:opacity .2s;opacity:.6;cursor:pointer}.monaco-live-analysis-override:before{content:\"\\F0AA\";font:normal normal normal 10px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#4da6ff}.monaco-live-analysis-override:hover{opacity:1!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/monaco/addons/liveAnalysis.css
 ** module id = 193
 ** module chunks = 0
 **/